<template>
  <div ref="fristhome">
    <el-card class="box-card">
      <el-form
        label-width="120px"
        :inline="true"
        size="mini"
        :model="addForm"
        ref="addForm"
        :rules="rules"
      >
        <el-row :gutter="24">
          <el-col>
            <div class="table_box">
              <el-table
                :data="list"
                v-horizontal-scroll="'always'"
                border
                size="mini"
                style="width: 100%;"
                stripe
                height="260"
              >
                <el-table-column prop="file_name" width="130px" label="文件名称" align="center" />
                <el-table-column prop="create_time" width="180" label="时间" align="center" />

                <el-table-column prop="plate_number" width="130px" label="文档" align="center">
                  <template slot-scope="scope">
                    <el-link type="primary" v-if="scope.row.url" @click="openFile(scope.row.url)">预览</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
        <iframe
          src="https://xingcuohl.shandonghuixing.com/storage/upload//20241204/8c3de3ad9564c2b7c248e9205abf5852.pdf"
          style="width: 100%; height: 800px"
        ></iframe>
        <iframe
          src="https://zkycyd.oss-cn-beijing.aliyuncs.com/car/policy/c5adafaa3d86a8c512b5dc55dc13869c01ce13c5.pdf"
          style="width: 100%; height: 800px"
        ></iframe>
      </el-form>
    </el-card>
    <!-- <previewpdf /> -->
    <!-- <pdf
      src="https://xingcuohl.shandonghuixing.com/storage/upload//20241204/8c3de3ad9564c2b7c248e9205abf5852.pdf"
      style="width: 100%;height:500px"
    ></pdf>-->
  </div>
</template>
<script>
import moment from "moment";
import Watermark from "../../utils/waterMark";
// import previewpdf from "../../components/previewpdf.vue";
export default {
  name: "amendment",
  components: {
  },
  directives: {},
  data() {
    return {
      list: [],
      docUrl: "",
    };
  },
  mounted() {
    this.getProductList();
  },
  methods: {
    openFile(docUrl) {
      // this.docUrl = docUrl;
      // console.log(this.docUrl, 1);
      const url = encodeURIComponent(docUrl);
      const officeUrl = "https://view.xdocin.com/view?src=" + url;
      // 在新窗口打开编码后 的链接
      window.open(officeUrl, "_target");
    },
    getProductList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        page: 1,
        limit: 1000,
      };
      this.$axios.errorLists(param).then((res) => {
        if (res.code == 200) {
          this.list = res.data.data;
          console.log(this.list, 123456);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/view/insurance/amendment.vue